import React from 'react';

export type ButtonProps = {
	label: string;
	onClick: () => void;
	small?: true;
}
type Props = ButtonProps;

const Button: React.FC<Props> = ({
	label,
	onClick,
	small,
}) => {
	return (
		<div
			className="button"
			style={{
				cursor: 'pointer',
				padding: '8px 30px',
				border: '2px solid white',
				borderRadius: '3px',
				fontFamily: 'Korinna',
				textTransform: 'uppercase',
				fontSize: '24px',
				whiteSpace: 'nowrap',
				textAlign: 'center',
				...small ? {
					padding: '4px 15px',
					border: '1px solid white',
					fontSize: '12px',
				} : {}
			}}
			onClick={onClick}
		>
			{label}
		</div>
	);
};

export default Button;
